import { render, staticRenderFns } from "./CoRIPanelReview.vue?vue&type=template&id=076caaa7&"
import script from "./CoRIPanelReview.vue?vue&type=script&lang=js&"
export * from "./CoRIPanelReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports